import api from 'config/axiosConfig';

export const getCategoryList = id => {
  return api.get(`api/categories/${id}`);
};
